module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '    <div class="ntop-bg" >\r\n        <div class="ntop g-pr" id="newsTop" style="width: 1180px;">\r\n            <ul class="nt_left f-fl">\r\n                ';
 nav_left.forEach(function(value){ ;
__p += '\r\n                <li class="ntl_' +
((__t = ( value.id )) == null ? '' : __t) +
' f-fl g-pr">\r\n                    ';
 if(value.url) {;
__p += '\r\n                    <a href = "' +
((__t = ( value.url )) == null ? '' : __t) +
'" >\r\n                        ' +
((__t = ( value.name )) == null ? '' : __t) +
'\r\n                    </a>\r\n                    ';
 }else {;
__p += '\r\n                    ' +
((__t = ( value.name )) == null ? '' : __t) +
'\r\n                    ';
 if(value.pic == 1) {;
__p += '\r\n                    <i class="d_triangle b_t_blue"></i>\r\n                    <div class="nt_login g-pa f-tc" id="nt_login" style="display: none;">\r\n                        <p class="title g-lh34px f-tc">同花顺交易平台</p>\r\n                        ';
nt_login.forEach(function(value){;
__p += '\r\n                        <p class="' +
((__t = ( value.class )) == null ? '' : __t) +
' f-tc">\r\n                            <a href="' +
((__t = ( value.url )) == null ? '' : __t) +
'">\r\n                                <b>' +
((__t = ( value.top )) == null ? '' : __t) +
'</b>\r\n                                <span class="g-fs12px g-lh22px">' +
((__t = ( value.bottom )) == null ? '' : __t) +
'</span>\r\n                            </a>\r\n                        </p>\r\n                        ';
});
__p += '\r\n                        <p class="tip g-fs12px g-lh22px">证监会首批颁牌 &nbsp;同花顺旗下官方</p>\r\n                        <p class="number g-fs12px g-lh22px">同花顺理财客服热线：<i>952555</i></p>\r\n                    </div>\r\n                    ';
 } ;
__p += '\r\n                    ';
 } ;
__p += '\r\n                </li>\r\n                ';
});
__p += '\r\n            </ul>\r\n            <ul class="nt_right f-fr">\r\n                ';
 nav_right.forEach(function(value){ ;
__p += '\r\n                <li class="ntl_' +
((__t = ( value.id )) == null ? '' : __t) +
' f-fr g-pr">\r\n                    ';
 if(value.url) {;
__p += '\r\n                    <a href = "' +
((__t = ( value.url )) == null ? '' : __t) +
'" >\r\n                        ' +
((__t = ( value.name )) == null ? '' : __t) +
'\r\n                        ';
 if(value.pic == 1) {;
__p += '\r\n                            <i class="d_triangle"></i>\r\n                        ';
 } ;
__p += '\r\n                    </a>\r\n                    ';
 if(value.id == "product") {;
__p += '\r\n                    <div class="nt_deal g-pa" id="nt-deal" style="display: none">\r\n                        ';
nt_deal.forEach(function(value){;
__p += '\r\n                        <a href="' +
((__t = ( value.url )) == null ? '' : __t) +
'" class="g-lh34px">' +
((__t = ( value.desc )) == null ? '' : __t) +
'</a>\r\n                        ';
});
__p += '\r\n                    </div>\r\n                    ';
 }else if( value.id == "fundbus"){ ;
__p += '\r\n                    <div class="nt_deal nt_guide g-pa" id="nt_guide" style="display: none">\r\n                        ';
nt_guide.forEach(function(value){;
__p += '\r\n                        <a href="' +
((__t = ( value.url )) == null ? '' : __t) +
'" class="g-lh34px">' +
((__t = ( value.desc )) == null ? '' : __t) +
'</a>\r\n                        ';
});
__p += '\r\n                    </div>\r\n                    ';
 } ;
__p += '\r\n                    ';
 }else {;
__p += '\r\n                        ' +
((__t = ( value.name )) == null ? '' : __t) +
'\r\n                        ';
 if(value.id == "nav") {;
__p += '\r\n                        <div class="nt_navbox g-pa" id="nt_navbox" style="display: none;">\r\n                            <div class="ntn_line f-fl">\r\n                                <p class="title f-tc g-lh34px">热点推荐</p>\r\n                                <div class="grade">\r\n                                    ';
grade.forEach(function(value){;
__p += '\r\n                                    <a href="' +
((__t = ( value.url )) == null ? '' : __t) +
'" class="g-lh34px">' +
((__t = ( value.desc )) == null ? '' : __t) +
'</a>\r\n                                    ';
});
__p += '\r\n                                </div>\r\n                            </div>\r\n                            <div class="ntn_line f-fl">\r\n                                <p class="title f-tc g-lh34px">基金数据</p>\r\n                                <div class="grade">\r\n                                    ';
grade2.forEach(function(value){;
__p += '\r\n                                    <a href="' +
((__t = ( value.url )) == null ? '' : __t) +
'" class="g-lh34px">' +
((__t = ( value.desc )) == null ? '' : __t) +
'</a>\r\n                                    ';
});
__p += '\r\n                                </div>\r\n                            </div>\r\n                            <div class="ntn_line f-fl g-lh34px">\r\n                                <p class="title f-tc g-lh34px">基金交易</p>\r\n                                <div class="grade">\r\n                                    ';
grade3.forEach(function(value){;
__p += '\r\n                                    <a href="' +
((__t = ( value.url )) == null ? '' : __t) +
'" class="g-lh34px">' +
((__t = ( value.desc )) == null ? '' : __t) +
'</a>\r\n                                    ';
});
__p += '\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        ';
 } ;
__p += '\r\n                        ';
 if(value.pic == 1) {;
__p += '\r\n                            <i class="d_triangle"></i>\r\n                        ';
 } ;
__p += '\r\n                    ';
 } ;
__p += '\r\n                </li>\r\n                ';
});
__p += '\r\n            </ul>\r\n        </div>\r\n    </div>';

}
return __p
}